import React from "react";
import styles from "./RequestVerificationStripeStyles.module.css";
import { InfoOutlined } from "@material-ui/icons";
import { useRequestVerificationModal } from "./modules/utils/useRequestVerificationModal";
import ExlyImage from "common/Components/ExlyImage";
import { COMMON_WIDTH_RESOLUTIONS } from "features/Common/modules/ExlyImage/constants/ExlyImage.constants";
import classnames from "classnames";

export const RequestVerificationStripe = ({ config }) => {
  const { openRequestVerificationModal, requestVerificationConfig } =
    useRequestVerificationModal(config);

  const {
    text = {},
    backgroundColor = "",
    btn = {},
  } = requestVerificationConfig;

  return (
    <div className={styles.container} style={{ "--bg-color": backgroundColor }}>
      <div className={styles.textWrapper}>
        <InfoOutlined className={styles.icon} />
        <div className={styles.text} style={{ "--text-color": text.color }}>
          {text.title}
        </div>
      </div>
      <div
        className={classnames(styles.btn, styles[btn.className])}
        style={{ "--btn-color": btn.color }}
        onClick={openRequestVerificationModal}
      >
        {btn.icon && (
          <ExlyImage
            src={btn.icon}
            fetchWidth={COMMON_WIDTH_RESOLUTIONS}
            className={styles.btnIcon}
          />
        )}
        <div className={styles.btnText} style={{ "--btn-color": btn.color }}>
          {btn.btnText}
        </div>
      </div>
    </div>
  );
};
